import { render, staticRenderFns } from "./trafficContracts.vue?vue&type=template&id=bd0525ba&"
import script from "./trafficContracts.vue?vue&type=script&lang=js&"
export * from "./trafficContracts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports